import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Campuscare = () => {
  return (
    <>
      <div className="campuslogo">
        <Link to="https://entab.online/ABSBBK" target="_blank">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/ABSB/public/Images/Campulogo.png"
              className="img-fluid float-end campus"
              alt="Anand Bhawan School, Barabanki"
            />{" "}
          </LazyLoad>
        </Link>
      </div>
    </>
  );
};

export default Campuscare;
